// extracted by mini-css-extract-plugin
module.exports = {"container":"Menu_container__3i1m6","menuIcon":"Menu_menuIcon__Gwxjh","active":"Menu_active__14unb","moduleMenuPopup":"Menu_moduleMenuPopup__nzMSf"};